import countryAliases from "./country-aliases.json";

const aliasMap = countryAliases as Record<string, string[]>;

export interface CountryLike {
  value?: string;
  label?: string;
  code?: string;
  name?: string;
}

const getCode = (item: CountryLike): string => item.value ?? item.code ?? "";

const getName = (item: CountryLike): string => item.label ?? item.name ?? "";

export const getCountryAliases = (code: string): string[] => {
  if (!code) return [];
  return aliasMap[code.toUpperCase()] ?? [];
};

const getSearchableTerms = (item: CountryLike): string[] => {
  const code = getCode(item);
  return [getName(item), code, ...getCountryAliases(code)];
};

export const matchesCountrySearch = (
  item: CountryLike,
  searchTerm: string,
): boolean => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return true;
  return getSearchableTerms(item).some((field) =>
    field.toLowerCase().includes(term),
  );
};

const startsWithCountrySearch = (item: CountryLike, term: string): boolean =>
  getSearchableTerms(item).some((field) =>
    field.toLowerCase().startsWith(term),
  );

export const filterCountriesBySearch = <T extends CountryLike>(
  data: T[],
  searchTerm: string,
): T[] => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return data;

  const startsWith = data.filter((item) => startsWithCountrySearch(item, term));
  const startsWithSet = new Set(startsWith);
  const contains = data.filter(
    (item) => !startsWithSet.has(item) && matchesCountrySearch(item, term),
  );

  return [...startsWith, ...contains];
};
